import type { EventPhase } from '../types'
import type { EventTarget } from './EventTarget'

/**
 * 事件基类，为 Rehaje 所有应用场景，提供领域事件自定义能力
 */
export abstract class TypedEvent<
  CurrentTarget extends EventTarget = EventTarget,
  Detail = any,
  Target extends EventTarget = EventTarget
> {
  __r_default_prevented?: boolean

  /**
   * 是否在事务中
   */
  __r_event_phase!: EventPhase

  __r_halted?: boolean

  /**
   * stopPropagation 已经执行
   */
  __r_terminated?: boolean

  bubbles = true
  cancelable = false
  currentTarget?: CurrentTarget
  detail?: Detail
  target?: Target
  timeStamp: number
  abstract type: string

  /**
   * 是否已被触发 preventDefault
   */
  get defaultPrevented() {
    return this.__r_default_prevented
  }

  /**
   * 事件执行阶段
   * 0: 非触发阶段
   * 1: 捕获阶段
   * 2: 触发自身阶段
   * 3: 冒泡阶段
   */
  get eventPhase() {
    return this.__r_event_phase
  }

  constructor(detail?: Detail) {
    this.detail = detail
    this.timeStamp = Date.now()
  }

  /**
   * 阻止默认行为
   */
  preventDefault() {
    this.__r_default_prevented = true
  }

  /**
   * 停止广播(只影响同级事件)
   */
  stopImmediatePropagation() {
    this.__r_terminated = true
  }

  /**
   * 停止广播(覆盖捕获与冒泡阶段)
   */
  stopPropagation() {
    this.__r_halted = true
  }
}
